import {GetRefundTableUrl} from 'domain/usecases';

import {RemoteRefundGetRefundTableUrl} from 'data/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {RefundFlowEndPoints} from '../../../endpoints';

export const makeGetRefundTableUrl = (): GetRefundTableUrl =>
	new RemoteRefundGetRefundTableUrl(
		makeBFFApiUrl(RefundFlowEndPoints.tableUrl),
		makeAuthorizeHttpClientDecorator(),
	);
